import React, { useEffect, useState } from "react";
import { Outlet } from "react-router";

function SessionValidation() {
  const [session, setSession] = useState(true);
  return <>{session ? <Outlet /> : null}</>;
}

export default SessionValidation;
